// extracted by mini-css-extract-plugin
export var alt = "History-module--alt--ef410";
export var circle = "History-module--circle--ea2cd";
export var circleContainer = "History-module--circleContainer--27774";
export var container = "History-module--container--5eecb";
export var controls = "History-module--controls--6047a";
export var description = "History-module--description--89058";
export var desktopOnly = "History-module--desktopOnly--2f490";
export var historyCarouselFull = "History-module--historyCarouselFull--fefce";
export var historyCarouselMobile = "History-module--historyCarouselMobile--79c32";
export var historyTitle = "History-module--historyTitle--e8077";
export var imageContainer = "History-module--imageContainer--79f69";
export var imageHistory = "History-module--imageHistory--30d58";
export var line = "History-module--line--08c11";
export var main = "History-module--main--3ac14";
export var mobileOnly = "History-module--mobileOnly--7c225";
export var subTitle = "History-module--subTitle--aa1bd";
export var textLeft = "History-module--textLeft--a1d94";
export var timeContainer = "History-module--timeContainer--44ec8";
export var timeContent = "History-module--timeContent--40e87";
export var visuallyHidden = "History-module--visuallyHidden--dc705";